import {StatusType} from "apm/types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import React from "react";

export default function StatusUI(val: StatusType|unknown) {
    if (val === 'approved')
        return SuccessUI;
    if (val === 'rejected')
        return RejectedUI;
    return 'Pending';
}
export const SuccessUI = <span className="text-success">
                <CheckCircleIcon/> Approved
              </span>;
export const RejectedUI = <span className="text-danger">
                <ErrorIcon/> Rejected
              </span>;